import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { hash } from '@ember/helper'
import { array } from '@ember/helper'
import { t } from 'ember-intl'
import { placeholderImage } from 'teacher-ui-client/helpers/placeholder-image'
import { ImgSizes } from 'teacher-ui-client/modifiers/img-sizes'

interface ImageData {
  width: number
  height: number
  url: string
}

interface Signature {
  Element: HTMLDivElement
  Args: {
    isFavourite?: boolean
    previewImg: ImageData
    bookCoverAlt: string
    onCoverLoad?: () => void
    fullImg: ImageData
  }
}

export const CollectionCardBody: TOC<Signature> = <template>
  <div ...attributes>
    {{#if @isFavourite}}
      <div class="border-dusty-black-200 flex h-56 w-48 flex-col items-center justify-center border">
        <PhosphorIcon @icon="phosphor-heart-fill" class="text-oceany-blue-350 h-8 w-8" />
      </div>
    {{else if @previewImg}}
      <img
        class="border-dusty-black-200 h-56 border object-contain"
        alt={{@bookCoverAlt}}
        {{ImgSizes
          sizes=(array
            (hash src=(placeholderImage width=@previewImg.width height=@previewImg.height))
            (hash src=@previewImg.url onLoad=@onCoverLoad)
            (hash src=@fullImg.url)
          )
        }}
      />
    {{else}}
      <div
        class="border-dusty-black-200 text-dusty-black-250 flex h-56 w-48 flex-col items-center justify-center border p-4 text-center"
      >
        <p class="mb-3">{{t "bookLibrary.components.collectionCard.empty"}}</p>
        <p class="mb-3">{{t "bookLibrary.components.collectionCard.emptyDescription"}}</p>
      </div>
    {{/if}}
  </div>
</template>
